import { Skill, SkillsGroup } from '../../../../types';

export const groupSkills = (skills: Skill[]): SkillsGroup[] => {
    const groups = new Map<string, SkillsGroup>();
    skills.forEach((skill) => {
        const { type } = skill;
        if (!groups.has(type.id)) {
            groups.set(type.id, { type, skills: [] });
        }
        groups.get(type.id)?.skills.push(skill);
    });
    return Array.from(groups.values());
};
